export const metaInfo = {
  name: "sample-app",
  version: "6.0.0",
  type: "sample",
  platform: "React",
};
